import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const esc = (s) =>
  String(s ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));

export async function downloadReportPdf({ t, fmt, data, monthLabel }) {
  const td = "padding:7px 10px;border-bottom:1px solid #E2E8F0;font-size:12px;color:#334155";
  const th = "padding:7px 10px;font-size:10px;color:#94A3B8;text-transform:uppercase;letter-spacing:1px;text-align:left;border-bottom:1px solid #CBD5E1";
  const tdNum = `${td};text-align:right;font-family:'JetBrains Mono',monospace;color:#0F172A;font-weight:600`;
  const thNum = `${th};text-align:right`;

  const monthlyRows = data.monthly
    .map((m) => `<tr><td style="${td}">${esc(monthLabel(m.month))}</td>
      <td style="${tdNum};color:#059669">${fmt(m.income)}</td>
      <td style="${tdNum};color:#DC2626">${fmt(m.expense)}</td>
      <td style="${tdNum}">${fmt(m.net)}</td></tr>`)
    .join("");

  const catRows = data.expense_categories
    .map((c) => `<tr><td style="${td}">${esc(c.category)}</td><td style="${tdNum}">${fmt(c.amount)}</td></tr>`)
    .join("");

  const incRows = data.income_categories
    .map((c) => `<tr><td style="${td}">${esc(c.category)}</td><td style="${tdNum};color:#059669">${fmt(c.amount)}</td></tr>`)
    .join("");

  const topRows = data.top_receivables
    .map((c) => `<tr><td style="${td}">${esc(c.cari_name)}</td><td style="${tdNum}">${fmt(c.amount)}</td></tr>`)
    .join("");

  const period = data.period ? `${monthLabel(data.period.from)} — ${monthLabel(data.period.to)}` : "";
  const box = (label, value, color) =>
    `<div style="flex:1;border:1px solid #E2E8F0;border-radius:12px;padding:16px 20px">
      <div style="font-size:10px;color:#94A3B8;text-transform:uppercase;letter-spacing:1px">${label}</div>
      <div style="margin-top:6px;font-size:22px;font-weight:700;color:${color};font-family:'JetBrains Mono',monospace">${value}</div>
    </div>`;

  const section = (title, inner) =>
    `<div style="margin-top:28px">
      <div style="font-size:13px;font-weight:600;color:#0F172A;margin-bottom:8px">${title}</div>
      <table style="width:100%;border-collapse:collapse">${inner}</table>
    </div>`;

  const el = document.createElement("div");
  el.style.cssText = `position:fixed;left:-10000px;top:0;width:794px;background:#ffffff;padding:48px;font-family:'IBM Plex Sans',sans-serif;color:#0F172A`;
  el.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:space-between">
      <div style="font-size:18px;font-weight:700;letter-spacing:3px">İRA FİNANS</div>
      <div style="font-size:11px;color:#94A3B8;font-family:'JetBrains Mono',monospace">${esc(period)}</div>
    </div>
    <div style="margin-top:4px;height:2px;background:#0F172A"></div>
    <div style="margin-top:20px;font-size:20px;font-weight:600">${esc(t.rep.title)}</div>
    <div style="margin-top:20px;display:flex;gap:12px">
      ${box(t.rep.totalIncome, fmt(data.total_income), "#059669")}
      ${box(t.rep.totalExpense, fmt(data.total_expense), "#DC2626")}
      ${box(t.rep.totalNet, fmt(data.total_income - data.total_expense), "#0F172A")}
    </div>
    ${section(esc(t.rep.monthly), `<tr><th style="${th}">${esc(t.dash.monthNet.split(" ").slice(0, 1).join(" "))}</th><th style="${thNum}">${esc(t.app.income)}</th><th style="${thNum}">${esc(t.app.expense)}</th><th style="${thNum}">Net</th></tr>${monthlyRows}`)}
    ${section(esc(t.rep.expCat), `<tr><th style="${th}">${esc(t.app.category)}</th><th style="${thNum}">${esc(t.app.amount)}</th></tr>${catRows}`)}
    ${section(esc(t.rep.incCat), `<tr><th style="${th}">${esc(t.app.category)}</th><th style="${thNum}">${esc(t.app.amount)}</th></tr>${incRows}`)}
    ${topRows ? section(esc(t.rep.topCari), `<tr><th style="${th}">${esc(t.app.cari)}</th><th style="${thNum}">${esc(t.app.amount)}</th></tr>${topRows}`) : ""}
    <div style="margin-top:36px;font-size:10px;color:#94A3B8">İRA Finans — İRA Mühendislik · ${new Date().toLocaleDateString("tr-TR")}</div>
  `;

  document.body.appendChild(el);
  await new Promise((r) => setTimeout(r, 80));
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", logging: false });
  document.body.removeChild(el);

  const img = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "pt", "a4");
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  const ih = (canvas.height * pw) / canvas.width;
  let pos = 0;
  let remaining = ih;
  pdf.addImage(img, "PNG", 0, pos, pw, ih);
  remaining -= ph;
  while (remaining > 0) {
    pos -= ph;
    pdf.addPage();
    pdf.addImage(img, "PNG", 0, pos, pw, ih);
    remaining -= ph;
  }
  pdf.save(`ira-finans-rapor-${new Date().toISOString().slice(0, 7)}.pdf`);
}
